import { render } from "./StudentPicker.vue?vue&type=template&id=0785fdec&scoped=true"
import script from "./StudentPicker.vue?vue&type=script&lang=js"
export * from "./StudentPicker.vue?vue&type=script&lang=js"

import "./StudentPicker.vue?vue&type=style&index=0&id=0785fdec&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0785fdec"]])

export default __exports__